// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WfLg","footer":"styles_footer__3-2qi","passCodeTooltip":"styles_passCodeTooltip__3E-Rn"};